import React from 'react';
import { motion } from 'framer-motion';
import logoImg from '../../assets/logob.webp';
import styles from './PendingApproval.module.css';

export default function PendingApproval({ onLogout }) {
    return (
        <div className={styles.container}>
            <motion.div
                className={styles.card}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <div className={styles.headerContainer}>
                    <img src={logoImg} alt="DBV Logo" className={styles.logo} width={180} height="auto" />
                </div>

                <h2 className={styles.title}>Richiesta inviata! ⏳</h2>

                <div className={styles.content}>
                    <p className={styles.text}>
                        La tua registrazione è andata a buon fine.
                        <strong> Il tuo account è in attesa di approvazione</strong> da parte degli amministratori.
                    </p>

                    <p className={styles.subtext}>
                        Non appena il tuo profilo sarà attivato, riceverai una notifica e avrai pieno accesso alla piattaforma.
                    </p>
                </div>

                <div className={styles.loaderContainer}>
                    <div className={styles.spinner}></div>
                    <span>In attesa...</span>
                </div>

                <button
                    className={`app-btn app-btn-secondary app-btn-block ${styles.logoutBtn}`}
                    onClick={onLogout}
                >
                    ESCI
                </button>
            </motion.div>
        </div>
    );
}
